import { TextField } from "@mui/material";
import { alertIfInvalidNumberEntry } from "./QuantityEntry";
import { handleWheel, handleKeyDown } from "../functions/eventHandlers";

const DecimalEntry = ({ elementName, fieldLabel, startingValue, setResourceState }) => {
    return <TextField style={{ width: "100%", marginTop: "12px", maxWidth: "260px" }}
        className="inputField" type='number' inputMode='numeric'
        autoComplete='off'
        label={fieldLabel} size="small" variant='outlined'
        value={(startingValue || startingValue === 0) ? startingValue : ''}
        onWheel={handleWheel}
        onKeyDown={handleKeyDown}
        onInput={alertIfInvalidNumberEntry}
        onChange={(e) => {
            if (e.target.value === null || e.target.value === "" || e.target.value === undefined) {
                setResourceState(prevState => { return { ...prevState, [elementName]: "" } });
            } else if (isNaN(e.target.value)) {
                setResourceState(prevState => { return { ...prevState, [elementName]: e.target.value } });
            } else {
                setResourceState(prevState => { return { ...prevState, [elementName]: parseFloat(e.target.value) } });
            }
        }} />
};

export default DecimalEntry;